module.exports = __webpack_public_path__ + "img/acw2.0feed20b.png";